import {useMemo} from 'react';

import {useGlobalSearchLines} from '../../queries/search/useGlobalSearchLines';
import {useStores} from '../../stores/use-stores';
import {OrderLine} from '../../transport/apiServiceResponse';
import {applyTierSort} from '../../utils/rewards';

/** Figma search dropdown (196:25412, 475:23215): five suggestion cards. */
export const HEADER_SEARCH_LIMIT = 5;

export type HeaderSearchLines = {
  lines: readonly OrderLine[];
  isLoading: boolean;
  isFetching: boolean;
};

/**
 * The header search suggestions (DIS-1907): SearchScreen's query, store id and tier sort, cut to
 * the first HEADER_SEARCH_LIMIT lines of the first page. Same query key as SearchScreen, so
 * "View All Results" opens on a cached first page. The page size stays at SearchScreen's 48: the
 * key does not carry it, so a smaller page under the same key would break SearchScreen's paging.
 * Call it from an observer: it reads the selected store from MobX.
 */
export const useHeaderSearchLines = (keywords: string): HeaderSearchLines => {
  const {shopSelectionStore} = useStores();
  const storeId = shopSelectionStore.selectedStore?.id ?? null;
  const query = useGlobalSearchLines(storeId, keywords);
  const firstPage = query.data?.pages?.[0]?.data;
  const lines = useMemo(
    () => applyTierSort(firstPage ?? []).slice(0, HEADER_SEARCH_LIMIT),
    [firstPage],
  );
  return {lines, isLoading: query.isLoading, isFetching: query.isFetching};
};
